import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const ModeInputHelperText = ({ text = undefined, tooltip = undefined, wide = false, slider = false }) =>
  <span className='helper-text'>
    { text && <span className={classNames({ 'slider-container': slider })}>{ text }</span> }
    { tooltip &&
      <OverlayTrigger
        placement='top'
        overlay={<Tooltip className={classNames({ 'tooltip-wide': wide })}>{tooltip}</Tooltip>}
      >
        <span className={classNames({ 'slider-tooltip': slider })}> (<a style={{ textDecoration: 'none' }}>?</a>)</span>
      </OverlayTrigger>
    }
  </span>;

ModeInputHelperText.propTypes = {
  text: PropTypes.string,
  tooltip: PropTypes.string,
  wide: PropTypes.bool,
  slider: PropTypes.bool,
};

export default ModeInputHelperText;
